export function getStatusColor(statusId: number): string {
  switch (statusId) {
    case 1: //return '#BBDEFB'; // Early - Light Blue
    case 2: return '#037d45'; // On Time - Dark Green
    case 3: return '#b89503'; // In Danger - Yellow
    case 4: return '#b80303'; // Late - Red
    case 5: return '#7c3aed'; // On Hold - Purple
    default: return '#E0E0E0'; // Unknown - Grey
  }
}

export function getStatusName(statusId: number): string {
  switch (statusId) {
    case 1: return 'Early';
    case 2: return 'On Time';
    case 3: return 'In Danger';
    case 4: return 'Late';
    case 5: return 'On Hold';
    default: return 'Unknown';
  }
}

export const shippedColor = '#5d7bd5';
export const productionOverrideColor = '#f28c28';
export const hotStatusColor = '#e5651f';


export function getResponsiblePartyColor(responsiblePartyId: number, isLight: boolean): string {
    switch (responsiblePartyId) {
      case 0: return isLight ? '#b2e9e5ff' : '#7fddd7ff';
      case 1: return isLight ? '#BBDEFB' : '#3572b0';
      case 2: return isLight ? '#c5c4ffff' : '#9a99fcff';
      case 3: return isLight ? '#ac889aff' : '#af497fff';
      default: return '#E0E0E0';
    }
  }

export function getActivityIcon(activity: any): string {
    if (activity.Icon) return activity.Icon;
    switch (activity.ResponsiblePartyId) {
      case 0: return 'person'; // Customer
      case 1: return 'sell'; // Sales
      case 2: return 'settings'; // Engineering
      case 3: return 'build'; // Production
      default: return 'circle'; // Other
    }
}
  
export function getResponsiblePartyName(responsiblePartyId: number): string {
  switch (responsiblePartyId) {
    case 0: return 'Customer';
    case 1: return 'Sales';
    case 2: return 'Engineering';
    case 3: return 'Production';
    default: return 'Unknown';
  }
}

export function getSourceName(sourceId: number): string {
  switch (sourceId) {
    case 0: return 'Unknown';
    case 1: return 'Order Status (AX)';
    case 2: return 'User Entry';
    case 3: return 'Calculated Default';
    case 4: return 'Work Center Import (AX)';
    default: return 'Unknown';
  }
}

export function cleanDescription(description: string): string {
  if (!description) return '';
  return description.replace(/^[0-9]+ - /, '');
}

export function formatDate(dateStr: string): string {
  if (!dateStr) return '';
  const utcDateString = dateStr.endsWith('Z') ? dateStr : dateStr + 'Z';
  const date = new Date(utcDateString);
  if (date.getFullYear() < 1980 || !date.valueOf()) return 'N/A';
  return date.toLocaleString('en-US', {
    timeZone: 'UTC',
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });
}